module.exports = __webpack_public_path__ + "4ac8da21610c1b44f9707bf65d357dcb.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/demo-ui/asset/icon-font/fontello.woff2
// module id = 701
// module chunks = 0